export const DEFAULT_VALUE_CURRENT_SEARCH_BAR = {
  ctaColor: "#0dbafc",
  ctaCopy: "SEARCH & SAVE",
  inputPlaceholder: "Try... Nike, Shoes, Starbucks or Coffee",
  subtitle: "Unlock discounted gift cards and today's best offers with GCX.",
  title: "Save more everywhere you shop."
};

export const POSSIBLE_MODAL_ALERT_CONTENTS = {
  FORM_ALERT: "form_alert",
  SUCCESS_FEEDBACK: "success_feedback",
  CANCEL_CONFIRMATION: "cancel_confirmation",
  CANCEL_ALERT_FEEDBACK: "cancel_alert_feedback"
};
